<div class="row" style="padding-top: 8px">
  <div class="col-md-12">
    <!--h2 class="heading">Messages</h2-->

    <div #messagesScrollContainer
         infinite-scroll
         [scrollWindow]="true"
         [fromRoot]="false"
         [infiniteScrollUpDistance]="1.5"
         [infiniteScrollDistance]="1.5"
         [infiniteScrollThrottle]="150"
         (scrolled)="onScrollDown($event)"
    >

      <p-table #messageTable [value]="messages"

               class="messageTable table table-condensed table-hover xtable-fixed-header"
               sortField="messageCreatedMs" sortOrder="-1">
        <ng-template pTemplate="header">
          <tr class="table-header-upper-row">
            <th style="width: 140px;">Time</th>
            <th style="width: 140px;" *ngIf="reportType !== 'patient'">Name</th>
            <th style="width: 250px;">Destinator</th>
            <th style="width: 60px;">Media</th>
            <th style="width: 110px;">Message Type</th>
            <th style="width: 60px;">View</th>
            <th style="width: 200px;">Status</th>
            <th style="width: 100%;">Details</th>
          </tr>
          <tr class="table-header-lower-row">
            <th></th>
            <th *ngIf="reportType !== 'patient'"></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>
              <p-multiSelect
                  [panelStyle]="{minWidth:'100%'}"
                  [options]="messageStateOptions"
                  [(ngModel)]="selectedMessageStates"
                  (onChange)="messageTable.filter($event.value, 'messageState', 'in');"
                  [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                  'padding-left': '16px', 'text-shadow': 'none', 'font-size': '12px'}">
                <p-header style="color: black; position: fixed; margin-left: 21px; font-size: 12px">
                  Select / Deselect All
                </p-header>
                <ng-template let-value pTemplate="selectedItems">
                <span *ngIf="value && value.length > 0"
                      class="ui-multiselected-empty-token ui-corner-all" style="font-size: 11px">{{value.length}} selected</span>
                </ng-template>
                <ng-template let-appointmentState pTemplate="item">
                <span class="message-status-item" style="font-size: 11px">{{appointmentState.label}}
                </span>
                </ng-template>
              </p-multiSelect>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-message let-columns="columns">
          <tr class="table-row ui-selectable-rows">
            <td style="line-height: 25px; width: 130px; text-align: left;">{{message.createdMs | amDateFormat: 'MM/DD/YYYY h:mm a'}}</td>
            <td *ngIf="reportType !== 'patient' && message.personId">
              <a href="patients/messages?patientid={{message.personId}}"
                 (click)="setRoute('patients/messages' ,'patientid', message.personId)"
            >{{message.firstName}}
              {{message.middleName}} {{message.lastName}}</a></td>
            <td *ngIf="reportType !== 'patient' && message.personId === undefined">
              {{message.firstName}} {{message.middleName}} {{message.lastName}}</td>
            <td style="line-height: 25px; text-align: left;">{{message.destinatorAddress}}</td>
            <td style="line-height: 25px; text-align: left;"><span
                tooltip="{{message.emailSubject}}">{{'_media_' + message.mediaType + '_' | translate}}</span></td>
            <td style="line-height: 25px; text-align: center;">
              <span *ngIf="message.contentCategory"
                    tooltip="{{'_communicationsCategory_' + message.contentCategory + '_' | translate}} {{message.jobName ? '(' + message.jobName + ')' : ''}}">
                  <img style="height: 30px; margin-top: -8px; margin-bottom: -6px;"
                       [src]="iconByMessageType(message.contentType)">
              </span>
            </td>
            <td style="text-align: left;">
              <button style="padding: 0px; width: 30px; height: 25px;" type="button" class="btn btn-default"
                      (click)="openMessageDisplayDialog(message)"
                      tooltip="Click to view message">
                <span class="glyphicon glyphicon-eye-open"></span>
              </button>
            </td>
            <td style="line-height: 25px; text-align: left;">{{'_centralMessageState_' + message.messageState + '_' | translate}}
              <span
                  *ngIf="message.emailOpened>0"
                  tooltip="Opened {{message.emailOpened}} times"> (opened)
              </span>
            </td>
            <td style="line-height: 25px; text-align: left;"
                tooltip="messageId:{{message.messageId}} :: personId:{{message.personId}}">{{ displayDescription(message) }}
              <span *ngIf="reportType === 'patient'">Direction: <b style="color:#444">{{ message.direction }}</b></span>
            </td>
          </tr>
        </ng-template>
      </p-table>

    </div>

  </div>
  <div *ngIf="loading" style="width: 100%; text-align: center">
    <img src="/img/loading.gif" style="width: 32px;"/>
  </div>

</div>